if (!Number.prototype.formatWithSpaces) {
  Number.prototype.formatWithSpaces = function (): string {
    return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };
}

if (!String.prototype.formatWithSpaces) {
  String.prototype.formatWithSpaces = function (): string {
    return this.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };
}

if (!String.prototype.formatDateTime) {
  String.prototype.formatDateTime = function (): string {
    if (!this) return '';
    const date = new Date(this);
    return date.toLocaleString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
}

declare global {
  interface Number {
    formatWithSpaces(): string;
  }
  interface String {
    formatWithSpaces(): string;
    formatDateTime(): string;
  }
  interface Date {
    formatDateTime(): string;
  }
}

export function formatAmount(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return '0';
  return value.toString().formatWithSpaces();
}

export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '';
  return date.toString().formatDateTime();
}
